module.exports = __webpack_public_path__ + "img/logo-white.1c50cc87.png";